import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classnames from 'classnames';
import styles from './video-aspect-ratio.scss';
export let VideoAspectRatioMode = /*#__PURE__*/function (VideoAspectRatioMode) {
  VideoAspectRatioMode["FIT_TO_HEIGHT"] = "FIT_TO_HEIGHT";
  VideoAspectRatioMode["FIT_TO_WIDTH"] = "FIT_TO_WIDTH";
  return VideoAspectRatioMode;
}({});
const stylesMap = {
  [VideoAspectRatioMode.FIT_TO_HEIGHT]: styles.fitToheight,
  [VideoAspectRatioMode.FIT_TO_WIDTH]: styles.fitToWidth
};
const image16x9 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAIAAAC0SDtlAAAAGklEQVQYlWP8//8/AymAiSTVoxpoooGBgQEAMWADDx3noXgAAAAASUVORK5CYII=';
export class VideoAspectRatio extends React.Component {
  render() {
    const {
      children,
      mode
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement("img", {
      className: classnames(styles.ratioImage, stylesMap[mode]),
      src: image16x9,
      alt: "",
      "aria-hidden": "true"
    }), children);
  }
}
_defineProperty(VideoAspectRatio, "defaultProps", {
  mode: VideoAspectRatioMode.FIT_TO_WIDTH
});
//# sourceMappingURL=video-aspect-ratio.js.map